// react
import React from 'react';

// third-party
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// application
import Dropdown from './Dropdown';
import { localeChange } from '../../store/locale';
import { languages } from '../../data/generalData';

function DropdownLanguage(props) {
    const { locale, localeChange: changeLocale } = props;

    const language = languages.find((x) => x.locale === locale);

    const title = (
        <React.Fragment>
            <FormattedMessage id="topbar.language" defaultMessage="Language" />
            {': '}
            <span className="topbar__item-value notranslate">{language.code}</span>
        </React.Fragment>
    );

    const items = languages.map((item) => ({
        ...item,
        name: <span className="notranslate">{item.title}</span>,
    }));

    return (
        <Dropdown
            title={title}
            withIcons
            items={items}
            onClick={(item) => changeLocale(item.locale)}
        />
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

const mapDispatchToProps = {
    localeChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(DropdownLanguage);
